import React from 'react';

function TagButton(props) {
    return (
        <button className="focus:outline-none text-xs bg-gray-300 hover:bg-gray-400 text-gray-800 py-1 px-2 m-1 rounded-full ml-0" {...props}>
        {props.children}
      </button>   
    );
}

export default TagButton;
